import { AppState } from 'reducers';

export const getRegistrationDone = (state: AppState) =>
  state.registration && state.registration.registrationDone;

export const getNotVerified = (state: AppState) =>
  state.registration && state.registration.notVerified;
